import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';

// style
import s from './Drivers.css';

import getAllDriversQuery from './getAllDrivers.graphql';

// components
import Loader from '../../../components/Common/Loader/Loader';
import UsersList from '../../../components/SiteAdmin/Users/UsersList';
//meassage
import {  FormattedMessage } from 'react-intl';
import messages from '../../../locale/messages';

class Drivers extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired
  };

  static defaultProps = {
    usersDetails: {
      loading: true
    }
  }

  render() {
    const { usersDetails, usersDetails: { loading } } = this.props;

    return (
      <Loader type={"page"} show={loading}>
        <div className={s.root}>
          <div className={s.container}>
            <div className={s.heading}>
            <FormattedMessage {...messages.manageDriverHeading} />
            </div>
            <div className={s.paddingRoutesSection}>
              {
                !loading && <UsersList
                  usersDetails={usersDetails}
                  requestType={'drivers'}
                />
              }
            </div>
          </div>
        </div>
      </Loader>
    );
  }
}

export default compose(
  withStyles(s),
  graphql(getAllDriversQuery, {
    name: 'usersDetails',
    options: {
      variables: {
        currentPage: 1,
        requestType: 'drivers'
      },
      fetchPolicy: 'network-only'
    }
  })
)(Drivers);
